import { useState } from "react";
const Rewards = ({ rewardsList }) => {
  const [fiat, setFiat] = useState("usd");
  const changeFiat = () => {
    fiat === "usd" ? setFiat("eur") : setFiat("usd");
  };
  const isToday = (timestamp) => {
    const currentDate = new Date();
    const inputDate = new Date(parseInt(timestamp) * 1000);
    return (
      currentDate.getDate() === inputDate.getDate() &&
      currentDate.getMonth() === inputDate.getMonth() &&
      currentDate.getFullYear() === inputDate.getFullYear()
    );
  };

  const showFiat = (gain) => {
    return fiat === "usd" ? `${gain.usd} $` : `${gain.eur} €`;
  };

  return (
    <div>
      <div className="rewardsContainer">
        <div className="totalRewardsContainer">
          <div className="totalRewards">{`Total Rewards:`}</div>
          <div className="totalRewardsValue">{showFiat(rewardsList.total)}</div>
          <div className="dailyRewards">{`Today's Rewards:`}</div>
          <div className="dailyRewardsValue">{showFiat(rewardsList.today)}</div>
        </div>
        <div className="switchFiatBtnContainer">
          <button className="switchFiatBtn" onClick={changeFiat}>
            Switch to {fiat === "usd" ? "€" : "$"}
          </button>
        </div>
      </div>
      <div className="detailsContainer">
        <table className="detailsTable">
          <tbody>
            {rewardsList.detailedTxns.map((txn, idx) => {
              const date = new Date(1000 * txn.timestamp);
              return (
                <tr key={idx}>
                  <td>
                    {fiat === "usd"
                      ? `${txn.value.usd} $`
                      : `${txn.value.eur} €`}
                  </td>
                  <td>
                    {isToday(txn.timestamp)
                      ? `Today at ${
                          date.getHours() < 10
                            ? `0${date.getHours()}`
                            : date.getHours()
                        }:${
                          date.getMinutes() < 10
                            ? `0${date.getMinutes()}`
                            : date.getMinutes()
                        }`
                      : `${date.toDateString()} at ${date.getHours()}:${
                          date.getMinutes() < 10
                            ? `0${date.getMinutes()}`
                            : date.getMinutes()
                        }`}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { Rewards };
